export { CmxDashboardPaymentsCardComponent } from './cmx-dashboard-payments-card.component';
export { CmxDashboardPaymentsCardService } from './cmx-dashboard-payments-card.service';
